export default "__VITE_ASSET__76bc5165__"